export const getPageNameFromPath = (pathname = '') => {
  const normalizedPath = pathname.toLowerCase().replace(/^\/render[^/]*/, '');
  if (normalizedPath.includes('/b/') || normalizedPath.includes('/s/')) {
    return 'plp';
  }

  if (normalizedPath.includes('/pep/')) {
    return 'pep';
  }

  // Default fallback
  return 'unknown';
};

export const validateSearchVars = (data) => {
  if (!data || typeof data !== 'object') {
    return false;
  }

  // Required fields that must exist
  const requiredFields = [
    'storefilter',
    'channel',
    'skipInstallServices',
    'skipBuyitagain',
    'additionalSearchParams',
    'filter',
    'isBrandPricingPolicyCompliant',
    'keyword',
    'navParam',
    'orderBy',
    'pageSize',
    'startIndex',
    'storeId'
  ];

  // Check if all required fields exist
  if (!requiredFields.every((field) => field in data)) {
    return false;
  }

  if (typeof data.storefilter !== 'string') return false;
  if (typeof data.channel !== 'string') return false;
  if (typeof data.skipInstallServices !== 'boolean') return false;
  if (typeof data.skipBuyitagain !== 'boolean') return false;
  if (typeof data.filter !== 'object') return false;
  if (typeof data.isBrandPricingPolicyCompliant !== 'boolean') return false;
  if (typeof data.pageSize !== 'number') return false;
  if (typeof data.startIndex !== 'number') return false;

  if (!data.additionalSearchParams || typeof data.additionalSearchParams !== 'object') {
    return false;
  }

  if (!Array.isArray(data.additionalSearchParams.multiStoreIds)) {
    return false;
  }

  if (!data.additionalSearchParams.deliveryZip
    || typeof data.additionalSearchParams.deliveryZip !== 'string'
  ) return false;

  if (!data.additionalSearchParams.sponsored
    || typeof data.additionalSearchParams.sponsored !== 'boolean'
  ) return false;

  if (!data.orderBy || typeof data.orderBy !== 'object') {
    return false;
  }

  if (typeof data.orderBy.field !== 'string' || typeof data.orderBy.order !== 'string') {
    return false;
  }

  return true;
};

const NTT_PREFIX = '/Ntt-';

export const isNIncluded = (value) => {
  return (value ?? '').includes('N-');
};

export const getPathName = (path) => {
  if (path.split('?')[0]) {
    return path.split('?')[0];
  }
  return path;
};

export const validateNValue = (slug) => {
  const slugValue = slug ?? '';
  return slugValue.includes('N-');
};

export const isRefinedPage = (path) => {
  return (path ?? '').includes(NTT_PREFIX) || false;
};